import { Box } from '@mui/material'
import { RedLock, Verified } from 'assets/icons'
import i18n from 'i18n'
import { GroupVerified } from 'model/models/Group'
import { useMemo } from 'react'
import { GroupDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { isConvertedGroup } from 'utils/api/group_state'
import { removePrefix } from 'utils/object'

interface GroupTitleProps {
  iconHeight?: string
  group?: Model<GroupDoc> | GroupDoc
  align?: string
  locked?: boolean
  weight?: number
}

const titleSx = {
  '@media (max-height: 500px)': {
    fontSize: '16px'
  }
}

function GroupTitle(props: GroupTitleProps) {
  const shouldShowBadge =
    props.group?.VerifiedGroupStatus === GroupVerified.VERIFIED

  let titleWidth = 100

  if (shouldShowBadge) titleWidth -= 10
  if (props.locked) titleWidth -= 10

  const iconSize = props.iconHeight ?? '16px'

  const titleDynamicSx = useMemo(
    () => ({
      fontWeight: props.weight,
      marginRight: 2,
      flex: 1,
      maxWidth: `${titleWidth}%`,
      overflow: 'hidden',
      textAlign: i18n.dir() === 'rtl' ? ('right' as const) : ('left' as const)
    }),
    [props.weight, titleWidth]
  )

  const title = isConvertedGroup(props.group)
    ? removePrefix(props.group?.CalendarEmail ?? '')
    : props.group?.Name

  return (
    <Box
      fontSize={`${iconSize} !important`}
      height={'inherit'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={props.align ? props.align : 'center'}
    >
      <Box sx={{ ...titleSx, ...titleDynamicSx }}>{title}</Box>
      {shouldShowBadge && <Verified height={iconSize} width={iconSize} />}
      {props.locked && <RedLock height={iconSize} width={iconSize} />}
    </Box>
  )
}

export default GroupTitle
